const GraphQLQuery = require('app/graphql/Query');

class RangeSelect {

    defaultOptions(){
        return {
            '$select': $('<select/>'),
            'value' : '',

            'rangeOptionOffset': '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',

            'onChange': function(event,$select){},
            'cacheKey': 'ranges',
        };
    }
    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onChange = this.onChange.bind(this);

        this.$select  = this.settings.$select;
        this.value = this.settings.value;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$select.on('change',this.onChange);

        let ranges = window.getFromCache(this.settings.cacheKey);
        if(ranges){
            this.fillSelect(ranges);
        }else{
            this.loadData();
        }
    }

    loadData(){
        var self = this;


        let filters = {
            'root': true,
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
            'childs { id name parent { id } childs { id name parent { id } childs { id name parent { id } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                let items = data.edges;
                window.addToCache(self.settings.cacheKey,items);
                self.fillSelect(items);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });


        query.execute();
    }

    fillSelect(ranges){
        this.ranges = ranges;


        this.$select.html('');


        this.$select
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );

        for(var r in this.ranges){
            let range = this.ranges[r].node;

            let options = this.buildRangeOptions(range);
            for(var o in options){
                let $option = options[o];
                if($option.val() == this.value){
                    $option.attr('selected','selected');
                }
                this.$select.append($option);
            }
        }
    }

    buildRangeOptions(range,offset){
        let options = [];

        if(!offset){
            offset = '';
        }

        let $option = $('<option/>')
        .val(range.id)
        .append(offset + range.name);

        if(range.parent == null){
            $option.addClass('fw-bold');
        }

        options.push($option);
        if(range.childs && range.childs.length > 0){
            for(var c in range.childs){
                var child = range.childs[c];
                let childOptions = this.buildRangeOptions(child,offset+this.settings.rangeOptionOffset);
                for(var o in childOptions){
                    let $childOption = childOptions[o];
                    options.push($childOption);
                }
            }
        }

        return options;
    }

    onChange(event){
        this.value = this.$select.val();
        this.settings.onChange(event,this.$select);
    }
}

module.exports = RangeSelect;

